export default "__VITE_ASSET__BDojiSdu__"